module.exports = {
          srcSet: __webpack_public_path__ + "dd2989ca26fd3475ad3f72d70b2e278d-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "dd2989ca26fd3475ad3f72d70b2e278d-1168.png",width: 1168,height: 248}],
          src: __webpack_public_path__ + "dd2989ca26fd3475ad3f72d70b2e278d-1168.png",
          toString:function(){return __webpack_public_path__ + "dd2989ca26fd3475ad3f72d70b2e278d-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ABpRN/wqZUn+KWtL/SVtSf0AYzH9hVNN/v9Vev9XSjr9WlpC/glIJ/oADCgb/BAtH/4NLR7+DSwd/gIrGv45IR7+lzZE/mBKR/7BO0P/elpO+5rTI0uxK5JmAAAAAElFTkSuQmCC",
          width: 1168,
          height: 248
        }